import Image from '@/models/Image';
import Video from '@/models/Video';
import File from '@/models/File';
import UserPermissions from '@/models/UserPermissions'
import api from '@/services/api';
import EmailTemplate from '@/models/EmailTemplate';
export default class Formatter{

    static createAlias(title){       
        return title.replace(/å/gi, 'a').replace(/ä/gi, 'a').replace(/ö/gi, 'o').replace(/\s+/g, ' ').trim().replace(/ /g, '-').toLowerCase();
    }

    static formatArticles(articles){
        let count = articles.length;
        for (let i = 0; i < count; i++) {  
            articles[i] = this.formatArticle(articles[i]);        
        } 

        return articles;
    }

    static formatArticle(article){
        if(!article.sections) article.sections = [];
        if(!article.categories) article.categories = [];
        if(!article.tags) article.tags = [];
        article.security_groups = article.security_groups ? article.security_groups : [];
        
        article.ownerId = article.owner?.id ?? article.owner ?? 0;

        if(!article.read_by_contacts)
            article.read_by_contacts = [];
        else
            article.read_by_contacts = article.read_by_contacts.map(c => c.id)
        
        article.feature_image = this.formatImage(article.feature_image);

        return article;
    }

    static formatContacts(contactsToAccess){
        let contacts = [];
        for (let i = 0; i < contactsToAccess.length; i++) {              
            let contact = contactsToAccess[i].contact;
            contact.is_owner = contactsToAccess[i].is_owner;
            contact.user_blocked = contactsToAccess[i].user_blocked;
            contact.created_by_contact = contactsToAccess[i].created_by_contact || 0;
            contact.updated_by_contact = contactsToAccess[i].updated_by_contact || 0;
            contact.created_at = contactsToAccess[i].created_at || 0;
            contact.updated_at = contactsToAccess[i].updated_at || contactsToAccess[i].created_at;
            contact = this.formatContact(contact, contactsToAccess[i]);
            contacts.push(contact);
        }

        return contacts;
    }

    static formatContact(contact, contactToAccess){
        contact.access_groups = contactToAccess.access_groups;
        contact.contactToAccessId = contactToAccess.id;

        contact.avatar = this.formatImage(contact.avatar);

        return contact;
    }

    static formatImage(data){
        if (!data || (!data?.formats && !data?.width && !data?.height))
            return null;
        
        if (data.formats)
            return new Image(data.formats.small?.url, data.formats.medium?.url, data.formats.large?.url, data.url, data.width, data.height, data.id, data.name);
    
        return new Image(null, null, null, data.url, data.width, data.height, data.id, data.name);
    }

    static formatVideo(data){
        if(!data || !data.file_guid)
            return null;
        
        return new Video(data.file_guid, data.url1, data.title, data.description, data.url2, data.url3, data.id);
    }

    static formatFiles(data){
        let files = [];
        let count = data.length;
        for (let i = 0; i < count; i++) {
            files.push(this.formatFile(data[i]));
        }
        return files;
    }
    
    static formatFile(data){
        return new File(data.id, data.ext, data.url, data.name);
    }

    static getCompleteUrl(url){
        return url ? api.defaults.baseURL + url : null;
    }

    static formatUserPermissions(data){
        if(!data || !data.contact || !data.portfolio || !data.id)
            return;
        
        return new UserPermissions(data.id, data.portfolio.id, data.contact.id, data.permissions); 
    }
    
    static formatEmailTemplate(data){
        if(!data || !data.emailTemplate)
            return;
        
        return new EmailTemplate(data.emailTemplate.id, data.emailTemplate.identifier, data.emailTemplate.template_id, data.emailTemplate.template, data.emailTemplate.from_sender, data.emailTemplate.subject, data.emailTemplate.substitution_fields);
    }
}